<template>
    <div class="home">
        <el-table
            :data="tableData"
            style="width: 100%"
            :show-header=false
            >
            <el-table-column
                prop="name"
                label="展会名称"
                width="800">
            </el-table-column>
            <el-table-column
                label="操作"
                width="200">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                </template>
            </el-table-column>
        
        </el-table>
        <el-dialog
            title="2020北京国际风能大会暨展览会"
            :visible.sync="DialogVisible_1"
            width="80%"
            center>
            <span>北京国际风能大会暨展览会（CWP）自2008年首次举办至今，越来越多的风电企业、专家学者、技术精英加入CWP大家庭，探讨技术、分享经验、谋划发展，使得CWP成为名符其实的中国风电产业发展的风向标和晴雨表。
            CWP论坛涵盖政策与市场趋势、行业热点、领先技术、企业家论坛等内容，汇聚了全球风电行业最具智慧大脑，思想碰撞中构建起动态的全球风电经纬网，描绘出生动的行业发展宏伟蓝图。
                <p>2020年10月14-16日，诚邀关注中国及世界风电发展的各界人士，与我们携手并肩共谋产业发展，探索能源转型。</p>

                <p>展会时间：2020年10月14日至16日</p>
                <p>展会地点：中国国际展览中心（新馆）</p>
                <p>报到时间：特装展位展商 2020 年 10 月12-13 日 8:30-17:00</p>
                <p>标准展位展商 2020 年 10 月 13 日 8:30-17:00</p>
                <p>撤展时间：2020 年 10 月16 日 15:00-21:00，15:00 以前参展商不得将展品搬离展位。</p>
                <p><el-image
                        style="width: 500px; height: 350px"
                    src='static/1.png'
                    ></el-image> </p>

            </span>
            <span slot="footer" class="dialog-footer">    
                <el-button type="primary" @click="DialogVisible_1 = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="2020（第十四届）中国国际酒、饮料制造技术及设备展览会（CBB 2020）"
            :visible.sync="DialogVisible_2"
            width="80%"
            center>
            <span>CBB秉承高度国际化办展风格，全球网络的专业观众邀约，立足于酒、饮料全产业链，全面覆盖液体食品加工和包装全产业链等诸多特色，被业界誉为两年一度最为重要的行业盛会和新品发布平台。经过20余年的发展，CBB已成为亚洲最具规模和影响力的标杆性展会，推动了液体食品加工及包装行业在中国的发展。
                <p>CBB 2020将继续发挥世界顶级行业展会的专业性和国际性优势，扩大规模和展品范围，立足中国经济发展核心区，辐射泛亚太地区经济圈，充分利用经济发达、产业聚集的区位优势，进一步扩大国际影响力，提升国际化服务，吸引更多中外展商和观众，打造液体食品加工及包装完整产业链商务平台，全方位服务于液体食品加工及包装行业。</p>

                <p>展会时间：2020年10月13日至16日</p>
                <p>展会地点：中国 •上海新国际博览中心（上海市浦东新区龙阳路2345号）</p>
                <p>布展时间：2020年10月10日至12日</p>
                <p>撤展时间：2020年10月16日至17日</p>
                
                <p><el-image
                        style="width: 500px; height: 350px"
                    src='static/2.png'
                    ></el-image> </p>

            </span>
            <span slot="footer" class="dialog-footer">    
                <el-button type="primary" @click="DialogVisible_2 = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="中国国际石油石化技术装备展览会（简称cippe）"
            :visible.sync="DialogVisible_3"
            width="80%"
            center>
            <span>中国国际石油石化技术装备展览会（简称cippe），是国际石油石化行业例会。cippe吸引了来自65个国家和地区的1800家展商，世界500强企业46家，18个国际展团，专业观众120,000人次，展会面积90,000平米，目前已成为一年一度的世界石油装备大会。
                <p>从2001年至今，cippe已经成功举办19届。展会有美国、加拿大、德国、俄罗斯、苏格兰、英国、法国、意大利、韩国等18大国际展团参展。国际展商包括埃克森美孚、俄油、俄气、俄罗斯管道、卡特彼勒、国民油井、斯伦贝谢、贝克休斯、GE、卡麦龙、霍尼韦尔、飞利浦、施耐德、陶氏化学、罗克韦尔、康明斯、阿克苏、API、3M、E+H、MTU、ARIEL、KSB、泰科、阿特拉斯、山特维克、赫普、雅柯斯、海虹老人等。</p>
                <p>国内知名参展企业有中石油装备展团、中石化、中海油、中国船舶、中船重工、中国航天、中航工业吉航、中集来福士、宏华、杰瑞、科瑞、南阳二机、三一集团、北方重工、中信泰富、惠博普、杰利阳、恒泰艾普、安东石油、上海神开、铁虎石油、西部石油、华油能源、泰富重装、海油集团、西安科迅、东方先科、金碧集团陕汽金玺、冠能固控、华油飞达、中油科昊、如石机械、道森集团、天津立林、海洋王、华荣防爆等。</p>
                <p>展会有新华社、人民日报、中央电视台、中国日报、中国石油报、中国石化报、Upstream、Worldoils、Oil and Gas Australia、Offshore World、Interfax、中国证券报、上海证券报、第一财经日报、华尔街日报及新华网、新浪、搜狐、人民网等国内外上千家媒体报道。</p>
                <p>第二十届中国国际石油石化技术装备展览会(cippe2020)，将于2020年8月26日—28日在中国•上海新国际博览中心举办，欢迎您届时参观参展！</p>
                <p>展会时间：2020年8月26日至28日</p>
                <p>展会地点：中国•上海新国际博览中心</p>
                
                <p><el-image
                        style="width: 500px; height: 350px"
                    src='static/3.png'
                    ></el-image> </p>

            </span>
            <span slot="footer" class="dialog-footer">    
                <el-button type="primary" @click="DialogVisible_3 = false">关闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="中国国际社会公共安全产品博览会"
            :visible.sync="DialogVisible_4"
            width="80%"
            center>
            <span>中国国际社会公共安全产品博览会（简称“安博会”, 英文“Security China”）是由中华人民共和国商务部批准，中国安全防范产品行业协会主办并承办的科技型展会。自1994年创办以来，安博会每两年在北京举办一届，至今已成功举办了十四届。二十余载的砥砺发展，安博会成为集产品展示、行业论坛、商贸洽谈、科技普及、技术推广等活动于一体，增进国际交流与合作，促进行业改革与创新，推动行业进步与发展，扩大我国安防行业国际影响力的高端品牌盛会。
                <p>2020安博会将于2020年10月21-24日在北京中国国际展览中心（新馆）举办。历届安博会始终坚持“展示先进技术、引领行业发展、服务市场需求、普及安防知识”的办展宗旨与服务理念，2020安博会将继续秉承这一理念，并以“创新驱动 科技引领 赋能安防”为主题，全面展示和集中推广安防行业新技术新产品。同时，还将举办中国安防高峰论坛、中国安防国际高峰论坛、中国安防技术发展峰会等多个行业论坛，以及优秀创新产品推荐、优秀行业解决方案推荐、新技术新产品发布会等多项精彩专题活动。</p>

                <p>展会时间：2020年10月21日至24日</p>
                <p>展会地点：北京中国国际展览中心（新馆）</p>
                <p>布展时间：2020年10月18日至20日</p>
                <p>撤展时间：2020年10月24日</p>
                
                <p><el-image
                        style="width: 500px; height: 350px"
                    src='static/4.png'
                    ></el-image> </p>

            </span>
            <span slot="footer" class="dialog-footer">    
                <el-button type="primary" @click="DialogVisible_4 = false">关闭</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    methods: {
      handleClick(row) {
        console.log(row.id);
        if (row.id == '1') {
            this.DialogVisible_1 = true
        }
        if (row.id == '2') {
            this.DialogVisible_2 = true
        }
        if (row.id == '3') {
            this.DialogVisible_3 = true
        }
        if (row.id == '4') {
            this.DialogVisible_4 = true
        }
        
      }
    },
    data() {
      return {
        DialogVisible_1: false,
        DialogVisible_2: false,
        DialogVisible_3: false,
        DialogVisible_4: false,
        tableData: [{
          id: '1',
          name: '2020北京国际风能大会暨展览会'
        }, {
          id: '2',
          name: '2020（第十四届）中国国际酒、饮料制造技术及设备展览会（CBB 2020）',
        }, {
          id: '3',
          name: '中国国际石油石化技术装备展览会（简称cippe）',
        }, {
          id: '4',
          name: '中国国际社会公共安全产品博览会',
          
        }]
      }
    }
}
</script>

<style scoped>
.p-0 {
    padding: 0!important;
}
.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
*, :after, :before {
    box-sizing: border-box;
    box */: ;
}
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
}

.card-img-top {
    width: 100%;
    border-top-left-radius: calc(.25rem - 1px);
    border-top-right-radius: calc(.25rem - 1px);
}

.card-body {
    flex: 1 1 auto;
    padding: 1.25rem;
}

.card-title {
    margin-bottom: .75rem;
}

.h5, h5 {
    font-size: 1.25rem;
}

h1, h2, h3, h4, h5, h6 {
    margin-top: 0;
    margin-bottom: .5em;
    color: rgba(0,0,0,.85);
    font-weight: 500;
}

.card-subtitle, .card-text:last-child {
    margin-bottom: 0;
}

p {
    margin-top: 0;
    margin-bottom: 1em;
}

.btn.product-btn {
    border: solid #06e2d6;
    width: 105px;
    background-color: #3c6698;
    color: #06e2d6;
}

.ml-auto, .mx-auto {
    margin-left: auto!important;
}

.mr-auto, .mx-auto {
    margin-right: auto!important;
}

.mb-4, .my-4 {
    margin-bottom: 1.5rem!important;
}

.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: .375rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    -webkit-transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

a {
    color: #1890ff;
    text-decoration: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    -webkit-transition: color .3s;
    transition: color .3s;
    -webkit-text-decoration-skip: objects;
}

body {
    margin: 0;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,PingFang SC,Hiragino Sans GB,Microsoft YaHei,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    font-variant: tabular-nums;
    line-height: 1.5;
    background-color: #fff;
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum","tnum";
}
</style>
